
const { ccclass, property } = cc._decorator;

@ccclass('SlotLine')
export class SlotLine {
    @property(cc.String)
    key: string = "";
    @property(cc.SpriteFrame)
    line: cc.SpriteFrame = null;
    @property(cc.SpriteFrame)
    lineSp1: cc.SpriteFrame = null;
    @property(cc.SpriteFrame)
    lineSp2: cc.SpriteFrame = null;
    @property(cc.SpriteFrame)
    corner: cc.SpriteFrame[] = [];
    @property(cc.SpriteFrame)
    point: cc.SpriteFrame = null;
    @property(cc.SpriteFrame)
    win: cc.SpriteFrame = null;
    @property(cc.SpriteFrame)
    box: cc.SpriteFrame = null;

    lineIndex: number
    lightColor: cc.Color
}
export enum SlotLineColor {
    Blue = "蓝色",
    Red = "红色",
    Yellow = "黄色",
    Green = "绿色",
    Purple = "紫色",
    MeiGuiHong = "玫瑰红",
    YingGuangLv = "荧光绿",
    CuiLv = "翠绿",
    JinHuang = "金黄",
    ShenLan = "深蓝",
}
@ccclass
export class SlotLineHolder extends cc.Component {
    @property(SlotLine)
    lines: SlotLine[] = [];

    getLineByName(key: string) {
        for (let idx = 0; idx < this.lines.length; idx++) {
            let line = this.lines[idx];
            if (line.key == key) {
                line.lightColor = this.getLightColor(line.key)
                line.lineIndex = idx
                return line;
            }
        }
        return null;
    }

    getLineByIndex(index: number) {
        this.lines[index].lightColor = this.getLightColor(this.lines[index].key)
        this.lines[index].lineIndex = index
        return this.lines[index]
    }
    getCornerByName(angle1, angle2, index) {
        for (let idx = 0; idx < this.lines[index].corner.length; idx++) {
            let name1 = `${angle1}-${angle2}`
            let name2 = `${angle2}-${angle1}`
            if (name1 == this.lines[index].corner[idx].name || name2 == this.lines[index].corner[idx].name) {
                return this.lines[index].corner[idx]
            }
        }
        return null
    }

    getLightColor(key) {
        switch (key) {
            case SlotLineColor.Blue:
                return this.hexToColor("0df5ff")
            case SlotLineColor.Yellow:
                return this.hexToColor("ffd736")
            case SlotLineColor.Red:
                return this.hexToColor("ff1d28")
            case SlotLineColor.Green:
                return this.hexToColor("40ff52")
            case SlotLineColor.Purple:
                return this.hexToColor("d928ff")
            case SlotLineColor.CuiLv:
                return this.hexToColor("27ffba")
            case SlotLineColor.JinHuang:
                return this.hexToColor("fffd3e")
            case SlotLineColor.MeiGuiHong:
                return this.hexToColor("ff39ae")
            case SlotLineColor.ShenLan:
                return this.hexToColor("3a5aff")
            case SlotLineColor.YingGuangLv:
                return this.hexToColor("adff2d")
            default:
                return this.hexToColor("ffffff")
        }
    }

    hexToColor(hex: String) {
        let str = [hex.substr(0, 2), hex.substr(2, 2), hex.substr(4, 2)]
        let r = parseInt(str[0], 16)
        let g = parseInt(str[1], 16)
        let b = parseInt(str[2], 16)
        return new cc.Color(r, g, b)
    }
}
